const audit = {
  title: "ביקורת קוד — סקירה רב-כובעית",
  subtitle: "בדיקת הקוד מ-4 זוויות: תוכנית, מציאות, איכות ושלמות",
  backToAdmin: "חזרה ללוג פיתוח",
  passed: "עובר",
  warnings: "אזהרות",
  failures: "כשלונות",
  infoItems: "מידע",
  totalChecks: "סה\"כ בדיקות",
  filterBy: "סנן לפי",
  filterAll: "הכל",
  noChecks: "אין בדיקות להצגה",
  summaryTitle: "סיכום לפי כובע",
  hat: "כובע",
  score: "ציון",
  overall: "סה\"כ כללי",
  resultPass: "עובר",
  resultWarn: "אזהרה",
  resultFail: "נכשל",
  resultInfo: "מידע",
  recommendation: "המלצה:",
  passCount: "עובר",
  warnCount: "אזהרה",
  failCount: "נכשל",
  infoCount: "מידע",
  totalLabel: "סה\"כ",
} as const;
export default audit;
